export const CAMPAIGN_DATA_OF_USER = 'campaign-data-of-user';
export const SALES_USERS_DATA = 'sales-users-data';
export const STATE_LIST = 'state-list';
export const DISTRICT_LIST = 'district_list';
export const CITY_LIST = 'city_list';
export const CLUSTER_LIST = 'cluster-list';
export const AUDIO_LIST = 'audio-list';



// WEBPACK FOOTER //
// ./web/action/salesUser_action_types.jsx